import React, { Component } from 'react'
import { connect } from 'react-redux'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction'
import Switch from '@material-ui/core/Switch'
import InboxIcon from '@material-ui/icons/MoveToInbox'
import DraftsIcon from '@material-ui/icons/Drafts'
import StarIcon from '@material-ui/icons/Star'
import SendIcon from '@material-ui/icons/Send'
import ServiceActions from '../redux/serviceRedux'
import DebugActions from '../redux/debugRedux'
import LayerActions from '../redux/layerRedux'
import MapActions from '../redux/mapRedux'
import TimestampActions from '../redux/timestampRedux'
import { authenticate } from '../api/Authenticate'
import { greenlandIce, smartIce } from '../config/services'

class DebugItems extends Component {
  render () {
    const { actions, pitchControlVisible } = this.props
    return (
      <div>
        <ListItem
          button
          onClick={() => actions.serviceUpdateRequested(greenlandIce)}
        >
          <ListItemIcon>
            <InboxIcon />
          </ListItemIcon>
          <ListItemText primary='getCapabilities greenlandIce' />
        </ListItem>
        <ListItem
          button
          onClick={() => actions.serviceUpdateRequested(smartIce)}
        >
          <ListItemIcon>
            <InboxIcon />
          </ListItemIcon>
          <ListItemText primary='getCapabilities smartIce' />
        </ListItem>
        <ListItem button onClick={() => authenticate.isAuthenticated()}>
          <ListItemIcon>
            <StarIcon />
          </ListItemIcon>
          <ListItemText primary='Authenticate' />
        </ListItem>
        <ListItem button onClick={actions.copyJwtToClipboardRequested}>
          <ListItemIcon>
            <StarIcon />
          </ListItemIcon>
          <ListItemText primary='Copy JWT' />
        </ListItem>
        <ListItem button onClick={actions.copyStoreToClipboardRequested}>
          <ListItemIcon>
            <StarIcon />
          </ListItemIcon>
          <ListItemText primary='Copy Store' />
        </ListItem>
        <ListItem>
          <ListItemIcon>
            <SendIcon />
          </ListItemIcon>
          <ListItemText primary='Pitch control' />
          <ListItemSecondaryAction>
            <Switch
              onClick={() => actions.pitchControlToggled()}
              checked={pitchControlVisible}
            />
          </ListItemSecondaryAction>
        </ListItem>
        <ListItem button onClick={() => actions.reset()}>
          <ListItemIcon>
            <DraftsIcon />
          </ListItemIcon>
          <ListItemText primary='Reset map & layers' />
        </ListItem>
        <ListItem
          button
          onClick={() => actions.timestampUpdateRequested('RiverIce')}
        >
          <ListItemIcon>
            <DraftsIcon />
          </ListItemIcon>
          <ListItemText primary='Update timestamps' />
        </ListItem>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    pitchControlVisible: state.map.pitchControlVisible
  }
}

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      serviceUpdateRequested: service =>
        dispatch(ServiceActions.serviceUpdateRequested(service)),
      pitchControlToggled: () => dispatch(MapActions.pitchControlToggled()),
      copyJwtToClipboardRequested: () =>
        dispatch(DebugActions.copyJwtToClipboardRequested()),
      copyStoreToClipboardRequested: () =>
        dispatch(DebugActions.copyStoreToClipboardRequested()),
      reset: () => dispatch(LayerActions.reset()),
      timestampUpdateRequested: layerName =>
        dispatch(TimestampActions.timestampUpdateRequested(layerName))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DebugItems)



// WEBPACK FOOTER //
// ./src/debug/DebugItems.js